module.exports = __webpack_public_path__ + "static/mccarthy-hall-2-thumb-e3941d63be96f43ce2fc69124bfcde47.jpg";